var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260,
    height: 88.074,
    viewBox: "0 0 260 88.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M0,32.381H260V-55.693H0Z",
    transform: "translate(0 55.693)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(0 55.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 -55.693)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(100.341 24.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M3.064,3.37A12.257,12.257,0,0,0,4.473-.084C3.395-1.213,1.862-1.393,1.361-2.072l2-1.944L3.73-5.788c-.109-.188-4.29,3.157-4.271,5.7V.142C-.583,1.3,2.612,2.386,2.612,2.386c-.625.838-6.533,3.528-7.882,3.927h.013c3.133.131,6.569,0,8.321-2.943",
    transform: "translate(5.27 5.796)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0.008 16.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M9.669,6.275C7.721,3.448,3.661.23-1.76-6.1c0,0-2.673-2.861-4.246-4.689l-.572,4.175C-3.561-2.233,2.135,3.936,8.913,10.034l-.414.642v.008c-4.259,2.257-15.05,7.226-19.156,7.29-6.329.109-3.912-8.843-3.394-10.4,0,0,.188-.626-.1-.786-1.192,2.965-6.33,15.866,3.051,15.741,5.348-.079,16.662-5.85,20.514-7.947,1.3-.7,1.308-2.785,1.32-3.745A7.73,7.73,0,0,0,9.669,6.275",
    transform: "translate(16.63 10.793)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(18.879 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M49.69,12.231l-.239-.285c-.408,1.377-.753,2.711-1.131,4.1,1.308,1.967,2.744,4.1,2.9,6.563-.166,1.558-3.906,2.113-6.865,2.17l-.011.016c-7.33-.016-6.582-4.722-6.527-6.716-.019.066-3.466,6.5-8.647,6.5-5.957-.321-7.849-4.306-7.956-7.1-.073-9.122-7.4-12.681-13.774-22.795l-.193-.307-2.284-3.8c1.06-1.079,26.571-7,31.048-7.961h.006c.939-.144,1.759.079,1.086,2.652-.773,2.87-3.661,10.467-4.937,14.022C34.9-5.4,41.786-21.317,38.617-21.033c-5.216,1.006-30.958,7.322-34.586,8.9-.356.656-.971,5.6-.663,5.848C8.76,3.1,16.556,10.28,18.658,14.241a3.355,3.355,0,0,1,.519,1.809C17.165,21.22.239,25.074-5.184,25.074a31.805,31.805,0,0,1-3.261-.16c7.116-12.041-10.317-35.588-14.309-42.529-1.238-2.01-1.743-2.937-1.743-2.937l-1.542,3.506c.691,3.954,2.366,30.873,2.388,32.769.011,2.249.068,2.307.062,4.983,0,3.443-6.073,3.311-6.855,3.2-2.133-.422-3.134-5.135-3.256-8.348-7.146,9.878-15.356,9.221-15.4,9.221-7.828-.939-8.113-12.049-8.364-18.59-.076-2.179-.028-20.966-.43-26.984a47.679,47.679,0,0,0-2.552,4.268c0,1.778.659,19.531.919,24.7.283,5.383-.977,10.366-5.386,14.5a10.306,10.306,0,0,0,.89-2.745c.8-9.473-9.753-18.832-16.625-29.674l-.218-.313s-2.929-5.287-3.563-6.19a25.948,25.948,0,0,0-1.034,4.45C-76.609,4.093-65.2,13.158-65.795,21.06A4.14,4.14,0,0,1-67,24.193a48.274,48.274,0,0,1-13.63,8.459h.762c3.783.145,10.433-1.517,13.409-3.841,4.254-3.311,7.249-9.387,7.993-13.126l.047-.212.027.19c.389,5.043.368,11.094,7.126,12.915,5.046,1.363,9.607-.99,12.692-3.343a38.614,38.614,0,0,0,4.063-3.745c0,2.856.571,5.048,1.877,5.9,2.2,1.42,5.3.759,5.3.759,7.251-1.335,6.18-10.607,6.18-14.889,0-5.364-1.656-22.905-1.861-25.513C-19.379-6.083-4.6,14.883-10.5,24.637a8.381,8.381,0,0,1-4.6-2.1,6.425,6.425,0,0,1-2.133-4.648c.021-3.957,2.714-7.76,2.714-7.76-2.885,2.662-4.439,8.108-4.439,10.018,0,4.531,2.652,7.045,6.084,8.152-1.667,2.064-1.967,2.519-3.043,3.715A21.39,21.39,0,0,0-11.321,28.7a16.984,16.984,0,0,0,3.168.291c14.049,0,26.1-5.8,27.922-10.548-.134,11.927,10.8,9.857,10.8,9.857,3.876-.685,5.247-2.763,6.489-4.4l.019.06c1.79,7.371,12.46,4.071,12.556,4.071,2.407-.6,3.228-6.133,3.228-8.181,0-2.894-1.528-5.427-3.174-7.613",
    transform: "translate(85.463 21.036)",
    fill: "#6e6861"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(139.447 -27.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M0,.978v.38L3.255,3.85,5.062,1.327,5.083.847,1.874-1.682Z",
    transform: "translate(0 1.682)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(146.025 -2.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M0,.978v.38L3.266,3.842l1.8-2.513L5.091.856,1.874-1.682Z",
    transform: "translate(0 1.682)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(68.988 -2.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M0,.978v.38L3.264,3.842l1.79-2.513L5.076.856l-3.2-2.538Z",
    transform: "translate(0 1.682)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(0 -55.693)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(0 63.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M0,0H7.618a8.518,8.518,0,0,1,3.035.489A5.987,5.987,0,0,1,12.767,1.8a5.3,5.3,0,0,1,1.267,1.945,6.7,6.7,0,0,1,.422,2.383,5.572,5.572,0,0,1-.389,2.089A5.669,5.669,0,0,1,13.123,9.8a5.062,5.062,0,0,1-1.215,1.048,3.25,3.25,0,0,1-1.2.467,7.606,7.606,0,0,1,1.575.452,5.163,5.163,0,0,1,1.6,1.028,5.58,5.58,0,0,1,1.246,1.784,6.585,6.585,0,0,1,.5,2.718,6.968,6.968,0,0,1-.663,3.226,5.619,5.619,0,0,1-1.784,2.07,6.982,6.982,0,0,1-2.679,1.113,15.857,15.857,0,0,1-3.3.327H0ZM7.14,10.017a5.8,5.8,0,0,0,1.487-.2,4.089,4.089,0,0,0,1.347-.633,3.177,3.177,0,0,0,.974-1.116,3.391,3.391,0,0,0,.376-1.66,3.522,3.522,0,0,0-.376-1.741,2.832,2.832,0,0,0-.974-1.048,3.652,3.652,0,0,0-1.347-.5A8.458,8.458,0,0,0,7.14,2.987H3.133v7.029ZM7.045,21.041a15.525,15.525,0,0,0,1.819-.1,5.032,5.032,0,0,0,1.73-.509,3.267,3.267,0,0,0,1.3-1.166,3.926,3.926,0,0,0,.5-2.151,3.953,3.953,0,0,0-.492-2.091,3.775,3.775,0,0,0-1.248-1.26A4.571,4.571,0,0,0,9,13.137a9.764,9.764,0,0,0-1.751-.163H3.133v8.067Z",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(17.357 70.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M3.937,5.6A5.251,5.251,0,0,1,1.632,7.476a7.422,7.422,0,0,1-2.948.612A7.029,7.029,0,0,1-3.26,7.819a5.009,5.009,0,0,1-1.752-.9A4.831,4.831,0,0,1-6.29,5.3a5.436,5.436,0,0,1-.482-2.432,5.58,5.58,0,0,1,1.76-4.322,7.3,7.3,0,0,1,5.1-1.623c.361,0,.742.014,1.145.035s.791.051,1.148.071.678.054.943.074a5.473,5.473,0,0,1,.572.073v-.612A3.161,3.161,0,0,0,2.837-6.125a4.636,4.636,0,0,0-2.875-.81,6.405,6.405,0,0,0-2.832.523,10.6,10.6,0,0,0-1.747,1.06l-1.419-2.2a7.5,7.5,0,0,1,.979-.721,8.383,8.383,0,0,1,1.344-.664,10.211,10.211,0,0,1,1.755-.508A11.5,11.5,0,0,1,.3-9.637,6.872,6.872,0,0,1,5.067-8.07,5.689,5.689,0,0,1,6.8-3.62V6.128c0,.59.006,1.086.035,1.494H4ZM3.9-.305c-.087-.022-.261-.049-.519-.087s-.558-.065-.9-.095-.7-.044-1.077-.073S.658-.588.3-.588a5.49,5.49,0,0,0-2.07.321A3.5,3.5,0,0,0-3.021.541a2.646,2.646,0,0,0-.626,1.077A4.277,4.277,0,0,0-3.81,2.753a2.526,2.526,0,0,0,.87,2.078,3.809,3.809,0,0,0,2.427.7,4.456,4.456,0,0,0,1.668-.321,4.875,4.875,0,0,0,1.4-.868,4.149,4.149,0,0,0,.979-1.26A3.185,3.185,0,0,0,3.9,1.6Z",
    transform: "translate(6.772 9.637)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(33.861 70.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M.013,1.484V-.446C.013-.986,0-1.556-.023-2.16h2.9l.1,2.53c.206-.293.451-.614.742-.954a5.185,5.185,0,0,1,1.077-.955A6.124,6.124,0,0,1,8.235-2.552a5.419,5.419,0,0,1,4.55,1.909,8.26,8.26,0,0,1,1.479,5.187V14.6h-3.03V4.8a5.163,5.163,0,0,0-.949-3.44A3.3,3.3,0,0,0,7.626.26,3.894,3.894,0,0,0,5.438.835,4.263,4.263,0,0,0,4.04,2.33,7.035,7.035,0,0,0,3.282,4.42a12.26,12.26,0,0,0-.237,2.4V14.6H.013Z",
    transform: "translate(0.023 2.552)",
    fill: "#6e6861"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(51.046 7.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M0,0V24.033H3.033V17.87l2.16-2.23,5.317,8.393h3.606L7.309,13.477l5.935-6.2H9.606L3.033,14.162V0Z",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(69.576 7.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M3.234,0l-8.8,24.033h3.406l2.325-6.7H9.4l2.329,6.7h3.606L6.541,0ZM4.787,3.856,8.426,14.41H1.107Z",
    transform: "translate(5.562)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M58.017,8.516h3.032V-15.517H58.017Z",
    transform: "translate(33.732 23.359)",
    fill: "#6e6861"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0 -55.693)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(97.817 63.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M0,0H3.032V9.114a5.965,5.965,0,0,1,.659-.721,5.172,5.172,0,0,1,1.02-.734,6.361,6.361,0,0,1,1.4-.563,7.018,7.018,0,0,1,1.773-.209,6.808,6.808,0,0,1,3.079.659,6.575,6.575,0,0,1,2.241,1.838,8.264,8.264,0,0,1,1.363,2.761,12.262,12.262,0,0,1,.455,3.387,10.016,10.016,0,0,1-.64,3.636,8.332,8.332,0,0,1-1.8,2.85A8.079,8.079,0,0,1,9.8,23.873a9.213,9.213,0,0,1-3.571.664,18.792,18.792,0,0,1-3.566-.321A13.933,13.933,0,0,1,0,23.459ZM3,21.259c.319.095.7.2,1.164.305a9.383,9.383,0,0,0,2.037.163,5.928,5.928,0,0,0,2.356-.446,5.3,5.3,0,0,0,1.808-1.268,5.52,5.52,0,0,0,1.162-1.944,7.314,7.314,0,0,0,.4-2.464,9.547,9.547,0,0,0-.251-2.22,5.651,5.651,0,0,0-.811-1.874,4.316,4.316,0,0,0-1.4-1.3,4.089,4.089,0,0,0-2.056-.487,4.25,4.25,0,0,0-1.937.414A4.2,4.2,0,0,0,4.1,11.228a4.325,4.325,0,0,0-.826,1.543A6.091,6.091,0,0,0,3,14.593Z",
    fill: "#6e6861"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M72.742-11.466h3.4V-15.1h-3.4Zm0-3.636.2,23.377h3.033V-8.474H72.94Z",
    transform: "translate(42.294 23.601)",
    fill: "#6e6861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M76.764,8.516H79.8V-15.517H76.764Z",
    transform: "translate(44.632 23.359)",
    fill: "#6e6861"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 -55.693)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(126.562 70.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M3.937,5.6a5.256,5.256,0,0,1-2.3,1.872,7.454,7.454,0,0,1-2.951.612,7.026,7.026,0,0,1-1.942-.269,4.975,4.975,0,0,1-1.751-.9A4.781,4.781,0,0,1-6.288,5.3a5.435,5.435,0,0,1-.484-2.432A5.578,5.578,0,0,1-5.007-1.456,7.29,7.29,0,0,1,.1-3.079c.359,0,.742.014,1.142.035s.792.051,1.151.071.674.054.941.074a5.663,5.663,0,0,1,.572.073v-.612A3.169,3.169,0,0,0,2.841-6.125a4.644,4.644,0,0,0-2.877-.81,6.4,6.4,0,0,0-2.832.523,10.616,10.616,0,0,0-1.749,1.06l-1.419-2.2a7.435,7.435,0,0,1,.982-.721,8.025,8.025,0,0,1,1.341-.664,10.272,10.272,0,0,1,1.757-.508A11.474,11.474,0,0,1,.3-9.637,6.876,6.876,0,0,1,5.07-8.07a5.7,5.7,0,0,1,1.74,4.45V6.128c0,.59,0,1.086.032,1.494H4.005ZM3.9-.305c-.089-.022-.259-.049-.522-.087s-.553-.065-.9-.095S1.79-.531,1.409-.56.661-.588.3-.588a5.474,5.474,0,0,0-2.07.321A3.494,3.494,0,0,0-3.018.541a2.611,2.611,0,0,0-.626,1.077,4.348,4.348,0,0,0-.164,1.135,2.531,2.531,0,0,0,.87,2.078,3.812,3.812,0,0,0,2.427.7,4.444,4.444,0,0,0,1.668-.321,4.832,4.832,0,0,0,1.4-.868,4.13,4.13,0,0,0,.98-1.26A3.224,3.224,0,0,0,3.9,1.6Z",
    transform: "translate(6.772 9.637)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(142.327 63.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M4.435,8.054c-.115.145-.3.365-.558.671a5.085,5.085,0,0,1-1.03.881,7.056,7.056,0,0,1-1.5.751,5.593,5.593,0,0,1-2,.327,6.312,6.312,0,0,1-2.763-.612A6.624,6.624,0,0,1-5.642,8.345,8.128,8.128,0,0,1-7.1,5.622a11.632,11.632,0,0,1-.523-3.585,9.8,9.8,0,0,1,.775-4.088A8.526,8.526,0,0,1-4.884-4.863a7.7,7.7,0,0,1,2.6-1.6,7.874,7.874,0,0,1,2.652-.5,6.394,6.394,0,0,1,2.62.429c.636.291,1.11.5,1.452.648v-7.962H7.468V8.471c0,.538.011,1.105.033,1.71H4.539Zm0-10.921a7.978,7.978,0,0,0-1.248-.772A5.629,5.629,0,0,0,.6-4.126a4.689,4.689,0,0,0-2.038.438A4.757,4.757,0,0,0-3.066-2.466,5.779,5.779,0,0,0-4.143-.521,8.115,8.115,0,0,0-4.53,2.071a8.942,8.942,0,0,0,.274,2.254,5.608,5.608,0,0,0,.824,1.858A4.026,4.026,0,0,0-2.016,7.428,4.352,4.352,0,0,0,.02,7.872,4.1,4.1,0,0,0,2.044,7.4a4.156,4.156,0,0,0,1.362-1.17,4.987,4.987,0,0,0,.778-1.545,5.681,5.681,0,0,0,.251-1.567Z",
    transform: "translate(7.628 13.852)",
    fill: "#6e6861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(178.39 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M24.882,0H-42.795V43.848A74.449,74.449,0,0,1-3.184,32.4a74.607,74.607,0,0,1,42,13.007V14.9C38.816,6.672,32.577,0,24.882,0",
    transform: "translate(42.795)",
    fill: "#f8b332"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(178.388 41.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M10.287,0a52.034,52.034,0,0,0-27.98,8.187V30.8c0,8.231,6.24,14.9,13.937,14.9H63.87C58.305,19.535,36.436,0,10.287,0",
    transform: "translate(17.693)",
    fill: "#d2202f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logo-svg.f5788fbbfa206f98a53ad5d78da500ca.svg";
export { ForwardRef as ReactComponent };